import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { constructionAsset, constructionSafety, logisticsAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';

export default {
  desc: 'Việc triển khai thông tin địa lý GIS của ORBRO tận dụng Digital Twin để cung cấp một hệ thống thông tin địa lý thời gian thực mang tính đổi mới, tích hợp bản đồ học chính xác và mô phỏng địa hình 3D.',
  keywords: 'Bản sao số, GIS, thành phố số, thực tế ảo, ban sao so, gis, thanh pho so, thuc te ao.',
  ogSite: 'Digital Twin - Xây dựng Thông tin địa lý GIS',
  title: 'Digital Twin - Xây dựng Thông tin địa lý GIS',
  ogUrl: 'https://orbro.io/vi/blog/digitaltwin-gis',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDmsHKPo0k1JGpYe5RqcLPvhvPsttOE54okj7zmGDmBsNO7w1O-JK1oTjUeN0SXoXeuVHVRR0yqY597xyclhreNiwqO8zxMhslWsAccGNFJL7Cc4jphNGY1U-ApF8rYUJlkQ29hCvXhs1-kJ7ItJ8yzqul6tD2bkCeeSf24qL0tmKPNG7wJdcdkE8HnxTJ-dAJvm-HQ1tD8-RFPjUfTcllJI-RCb7dzd6jATNYzQbe1GQD7gejTG574T2T6jKa1sIQLT1me2evIreAszenpfb2ZOAOafbrlQEnfJCF577BDuUZxdtYW-PpTWZdcoK_GlrZTVEXWFVIe4zYY4BA9uI-4MvLCytQ19heux-zPZ2uj0Pd-eu04szV3P6TFIG2dqGtdzui7sXRbRh4-9toRM1UEYley9vu4sOHPbxuwV1LN97GHKbtKrmz4OsgOS0jK8VWR0v_KCwr08MXIduU_b2QT5axXUH4CSftoADRRfaDprmZIqjdAdy7RqILvmsg_V7NQAcd9xapuxx4MMoC42nj2n0iwd9yZV--15jzcgqW6daHUiYEZ4ggt7Uy2LoPScqjh7hhOm8vT1XPj6fSf3W1SgBduBXU9h5e0_bG9GKZLWMCy72SHi0Xs0NO0X7FSOgdDU0scaP-F8WlOsTezavpMEhxUlz2fhL_mBIfZVO25KKS-y-Qfuul0bpf2coLNtuVO4yW_hZEZuAzW7FbuIUdoyI04V7I493a1IXz6-A_ZcTH2j2retDHu_nD6RnBrnlcCsY0tnVCMM0ho0k_GLGaGTrs_88IPxii47Y_Qa1XXH-8-wwpGN0UocvGhXB6rdM7S-m7_MIT3ONC4MyvE3Bqjkid-QLeYtThJ2zXLCXfCIaCyi4jttco-MJjx84qBVRrUWpwcvpISJ7E9pYCJukWT1rgVNPsgO1baez2jR2IyH1hMZ4SXB6nHNVoylyuvAjn1uYfjDCfOgRlqmcK8wt3U1GImqc68KthjcbhAjDNmlLNtBl9Pd4Ksg0Xts8R_Z_LbV6Ue834BoCmu5H_jzmEevCkvwPsYoLsmqebwEqmrp2B58f2e32e0YY8L8jPuMPX3UDZyxX98adUK-gekxc1YB5JrqJPlcC4nZA-XLh8EmakSbt83hYYjIkhbHeafd7Hr5M-Em9znV_sFo2DaAwfkAQRoa80pNidI39UxDJVdey6nVP9H6UPL-i_N-H1K6LpiALIwQNKPMlI4up5e-hme40ZgUL9QKbBaKDyfOxk1aqml1cTzHCZJRP_jLw2dOoS1K-EG7OsGJDxmnclokA0StmKuFCPLAbAodPa1K_Btbk2GtITh4kvm07TLOp_LDZBnztDlzA8WuId3bEWiXNRc5qKlfv5UYlEn_k4L03K4A-T49R-Pi75Jp53wW68HhGwDoSbyYjaiI8plzJeyMyGJduXJZtYWh66ETIXdt8IxUDYw5otbzXD-lFsSLdM09U37NH_lU0c07Sjg77a4m1OfI1-mfJmHzqzvn9kksa3H2aYES0HhIq5RPgdd0NyW7b2IvL9b7nDE4tL4D-hf70biexJ_aaBkb=w1923-h1074',
  ogType: 'website',
  date: '2023-12-26',
  tag1: '#Bansaoso',
  tag2: '#Gis',
  tag3: '#Thanhphoso',
  tag4: '#Thucteao',
  text: [
    {
      head: 'Digital Twin - Xây dựng hệ thống Thông tin địa lý GIS',
      subHead: '',
      desc: 'Việc triển khai thông tin địa lý GIS của ORBRO tận dụng Digital Twin để cung cấp một hệ thống thông tin địa lý thời gian thực mang tính đổi mới, tích hợp bản đồ học chính xác và mô phỏng địa hình 3D. Hệ thống này hỗ trợ các chuyên gia trong việc phân tích địa hình, lập kế hoạch cơ sở hạ tầng, và ra quyết định quản lý thiên tai, đồng thời phản ánh năng lực công nghệ mới nhất của ORBRO.\nMô hình địa hình 3D trực quan hóa hình dạng, độ dốc, và độ cao chính xác của địa hình, được ứng dụng trong phân tích môi trường, quy hoạch đô thị, và quản lý thiên tai. Dữ liệu cơ sở hạ tầng được số hóa bằng mô hình 3D và công nghệ GIS, và rất cần thiết cho phát triển đô thị cũng như ứng phó với thiên tai.\nThông tin tòa nhà được mô hình hóa bằng hình ảnh độ phân giải cao, dữ liệu thiết kế kiến trúc, và quét 3D, đóng vai trò quan trọng trong thiết kế kiến trúc và quy hoạch đô thị. Công nghệ GIS cung cấp thông tin cần thiết cho quy hoạch đô thị, tối ưu hóa luồng giao thông, bố trí dịch vụ công cộng, và cũng đóng vai trò then chốt trong ứng phó thiên tai, biến đổi và bảo vệ môi trường.',
      dot: '',
    },
    {
      head: 'Biểu đạt địa lý theo hình thái Trái Đất',
      subHead: '',
      desc: 'ORBRO tích hợp hình ảnh vệ tinh, dữ liệu địa hình, và Hệ thống Thông tin Địa lý (GIS) để xây dựng các mô hình địa hình 3D có độ phân giải cao. Mô hình này trực quan hóa hình dạng chính xác, độ dốc, độ cao, v.v., của địa hình theo thời gian thực và được sử dụng cho các quyết định quan trọng trong nhiều lĩnh vực như phân tích môi trường, quy hoạch đô thị, quản lý thiên tai và lập kế hoạch cứu hộ.',
      dot: '',
    },
    {
      head: 'Biểu đạt địa hình và cơ sở hạ tầng',
      subHead: '',
      desc: 'ORBRO thu thập dữ liệu cơ sở hạ tầng từ nhiều nguồn khác nhau và số hóa chúng bằng công nghệ mô hình 3D và GIS. Thông tin này rất cần thiết cho việc phát triển đô thị và khu vực, ứng phó với thiên tai và lập kế hoạch an toàn.',
      dot: '',
    },
    {
      head: 'Biểu đạt 3D thông tin tòa nhà',
      subHead: '',
      desc: 'ORBRO mô hình hóa chính xác cấu trúc bên ngoài và bên trong của các tòa nhà bằng cách sử dụng hình ảnh độ phân giải cao, dữ liệu thiết kế kiến trúc và công nghệ quét 3D. Việc mô hình hóa này đóng vai trò quan trọng trong thiết kế kiến trúc, quy hoạch đô thị, phát triển và thẩm định bất động sản.',
      dot: '',
    },
    {
      head: 'Cải thiện quy hoạch và quản lý đô thị',
      subHead: '',
      desc: 'Công nghệ GIS của ORBRO giúp cải thiện việc lập kế hoạch và quản lý trong các môi trường đô thị phức tạp. Thông qua đó, nó cung cấp thông tin thiết yếu cho việc tối ưu hóa luồng giao thông, bố trí các dịch vụ công cộng, quản lý mở rộng đô thị, v.v.',
      dot: '',
    },
    {
      head: 'Hỗ trợ ứng phó và chuẩn bị cho thiên tai',
      subHead: '',
      desc: 'ORBRO sử dụng công nghệ GIS để hỗ trợ việc ứng phó và chuẩn bị cho các thảm họa tự nhiên và tình huống khẩn cấp. Nó đóng vai trò quan trọng trong việc xác định các khu vực nguy hiểm, lập kế hoạch các tuyến đường sơ tán, bố trí nguồn lực cứu trợ, v.v., bằng cách tận dụng dữ liệu địa hình và cơ sở hạ tầng.',
      dot: '',
    },
    {
      head: 'Biến đổi môi trường và Bảo vệ môi trường',
      subHead: '',
      desc: 'GIS của ORBRO là một công cụ quan trọng để theo dõi và phân tích những thay đổi của môi trường. Thông qua công nghệ này, ORBRO góp phần vào việc theo dõi biến đổi hệ sinh thái, quản lý các khu bảo tồn thiên nhiên và xây dựng các chính sách bảo vệ môi trường.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
    ],
  },
};
